export default __webpack_public_path__ + "static/media/logo29.18bb9e05.png";